export default __webpack_public_path__ + "static/media/mobile.d4f7f43d.jpg";